module.exports = __webpack_public_path__ + "static/media/29ADMSPC39.19e2c197.jpg";